import { useIsMutating } from 'react-query';
import { Link } from 'react-router-dom';
import useQueryParams from 'utils/useQueryParams';
import ListingLayout from 'components/Layout/ListingLayout';
import ROUTES from 'app/routes';
import Table from 'pages/Users/Listing/components/Table';
import Footer from 'components/Footer';
import LoadingIndicator from 'components/LoadingIndicator';
import { useGetUsers } from 'api/users';

function Users() {
  const { queryString } = useQueryParams({
    page_size: '10',
    page: '1',
  });

  const isMutating = !!useIsMutating({ mutationKey: ['usersMutation'] });

  const { isFetching, data: { data: users, totals } = { data: [], totals: 0 } } = useGetUsers(queryString);

  const showLoading = isMutating || isFetching;

  return (
    <ListingLayout
      title="Użytkownicy"
      headerButtons={[
        {
          label: 'NOWY UŻYTKOWNIK',
          as: Link,
          to: ROUTES.users.create,
        },
      ]}
    >
      {showLoading && <LoadingIndicator />}
      {!showLoading && <Table data={users} />}
      <Footer totals={totals} footerButtons={null} />
    </ListingLayout>
  );
}

export default Users;
